<template>
  <div>
    <loader v-if="loading"/>
    <error-page v-else-if="hasError" :message="errorMessage"/>
    <router-view v-else/>
  </div>
</template>

<script>
  import RedirectException from '@/exceptions/redirectException';
  import Loader from './shared/LoginLoader';
  import ErrorPage from './appstructure/ErrorPage';

  export default {
    components: { Loader, ErrorPage },
    data() {
      return {
        loading: true,
        hasError: false,
        errorMessage: null
      };
    },
    mounted() {
      this.$auth.init()
        .then(() => {
          this.loading = false;
        }).catch((err) => {
          if (!(err instanceof RedirectException)) {
            throw err;
          }
        }).catch((err) => {
          this.errorMessage = err && err.message ? err.message : err;
          this.hasError = true;
          this.loading = false;
        });
    }
  };
</script>

<style>
</style>
